import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Modal from "react-modal";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router } from "react-router-dom";
import { Amplify } from "aws-amplify";
import Navbar from "./components/Navbar";

Modal.setAppElement("#root"); // Add this line here

Amplify.configure({
  Auth: {
    region: "us-east-1",
    Cognito: {
      userPoolId: "us-east-1_9TZFZfhvZ",
      userPoolClientId: "777bl6khkao8rors56jip5ik9m",
    },
  } as any,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <Navbar />

        <App />
      </Router>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
